import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Storage from 'vue-ls';
import Register from '../components/Register.vue'
import Router from "../components/Router.vue";
import VueMask from 'v-mask'

require('../css/catalog.css');

Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(Storage, {
    namespace: 'igr_',
    name: 'ls',
    storage: 'local',
});
Vue.use(VueMask);

const router = Router;

new Vue({
    router,
        render: function (h) {
        return h(Register);
    },
    el: '#Register',
    data: {
    },
    components: {
        Register
    },
    created() {
        this.$cookies.config('30d');
    },
    renderError (h, err) {
        return h('pre', { style: { color: 'red' }}, err.stack)
    }
});
